import type { ThreadSseEvent } from './types';

export function mapThreadSseEvent(eventType: string, data: any): ThreadSseEvent | null {
  if (eventType === 'thread_created' && data?.entity_id) {
    return {
      kind: 'thread_created',
      threadId: data.entity_id,
      subject: data.subject,
    };
  }

  // Fallback stream events can carry thread_id before/without direct thread_created.
  // Keep this limited to message_start to avoid duplicate thread_created handling on normal sends.
  if (eventType === 'message_start' && data?.thread_id) {
    return {
      kind: 'thread_created',
      threadId: String(data.thread_id),
      subject: data.subject,
    };
  }

  if (data?.entity === 'thread' && data?.entity_id) {
    if (data.action === 'updated') {
      return { kind: 'thread_updated', threadId: data.entity_id, subject: data.subject };
    }
    if (data.action === 'title_updated') {
      return { kind: 'thread_title_updated', threadId: data.entity_id, subject: data.subject };
    }
    if (data.action === 'summary_updated') {
      return {
        kind: 'thread_summary_updated',
        threadId: data.entity_id,
        summary: data.summary,
        updates_digest: data.updates_digest,
      };
    }
    if (data.action === 'created') {
      return { kind: 'thread_created', threadId: data.entity_id, subject: data.subject };
    }
  }

  return null;
}

